$.fn.extend({
    post: function (url, data, callback) {
        return $.ajax({
            url: url,
            type: 'POST',
            data: data,
            dataType: 'json',
            contentType: 'application/json',
            success: callback
        });
    },
    postJson: function (url, data, callback) {
        return $.ajax({
            url: url,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json',
            success: callback
        });
    },
    delete: function (url, callback) {
        return $.ajax({
            url: url,
            type: 'DELETE',
            dataType: 'json',
            contentType: 'application/json',
            success: callback
        });
    },
    getJson: function (url, callback) {
        return $.ajax({
            'type': 'GET',
            'url': url,
            'contentType': 'application/json',
            'dataType': 'json',
            'success': callback
        });
    },
    serializeObject: function(){
	    var o = {};
	    var a = this.serializeArray();
	    $.each(a, function() {
	        if (o[this.name] !== undefined) {
	            if (!o[this.name].push) {
	                o[this.name] = [o[this.name]];
	            }
	            o[this.name].push(this.value || '');
	        } else {
	            o[this.name] = this.value || '';
	        }
	    });
	    return o;
	}
});

String.prototype.padChar= function(len, c){
    var s= this, d= c || '0';
    while(s.length< len) s= d+ s;
    return s;
};